"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.visibleLabelsReducer = void 0;
var visibleLabelsReducer = function (state, action) {
    switch (action) {
        case 'show-all':
            state.fill(true);
            return state;
        case 'hide-all':
            state.fill(false);
            return state;
        default: {
            state[action] = !state[action]; // flip
            return state;
        }
    }
};
exports.visibleLabelsReducer = visibleLabelsReducer;
